// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import moment from "moment";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Col, Typography, Space, Tag } from "antd";
import { notify } from "@/shared/utils/notify";
import Table, { ColumnsType } from "antd/es/table";
import { RotateCw, Clock, CreditCard, Building2, Hash } from "lucide-react";
import { useSelector } from "react-redux";

import {
  selectOrderForUpdate,
  selectOrderPaymentConfirmations,
} from "../../../../redux/selectors/orders.selectors";
import {
  ordersService,
  paymentConfirmationsService,
} from "../../../../shared/services";
import useAppDispatch from "../../../../redux/hooks/useAppDispatch";
import {
  changeOrderPaymentConfirmations,
  setOrdersForUpdate,
} from "../../../../redux";
import { decimal } from "../../../../shared/utils/Helper";

const { Text } = Typography;

export const PaymentConfirmation = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const orderForUpdate = useSelector(selectOrderForUpdate);
  const OrderPaymentConfirmations = useSelector(
    selectOrderPaymentConfirmations
  );
  const [isLoading, setIsLoading] = useState(false);
  const getRefreshSingleOrder = async () => {
    if (isLoading) return;
    setIsLoading(true);
    return await ordersService
      .get(Number(id))
      .then((res) => {
        setIsLoading(false);
        return dispatch(setOrdersForUpdate(res));
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
        return notify.error(err.message);
      });
  };

  const getArrOfPaymentConfirmations = async () => {
    await paymentConfirmationsService
      .find({
        query: { order_id: orderForUpdate?.id, $limit: 9999999999999 },
      })
      //   .then((res: IPaymentConfirmationsFin) =>
      .then((res: any) => dispatch(changeOrderPaymentConfirmations(res.data)));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getArrOfPaymentConfirmations();
  }, []);
  const getStatusColor = (status: string) => {
    const statusLower = status?.toLowerCase() || "";
    if (statusLower.includes("aprobado") || statusLower.includes("approved") || statusLower.includes("success")) {
      return "green";
    }
    if (statusLower.includes("pendiente") || statusLower.includes("pending")) {
      return "orange";
    }
    if (statusLower.includes("rechazado") || statusLower.includes("rejected") || statusLower.includes("failed")) {
      return "red";
    }
    return "default";
  };

  const translateStatus = (status: string) => {
    if (!status) return "N/A";
    
    const statusLower = status.toLowerCase();
    const translations: { [key: string]: string } = {
      "approved": "Aprobado",
      "success": "Exitoso",
      "pending": "Pendiente",
      "rejected": "Rechazado",
      "failed": "Fallido",
      "declined": "Declinado",
      "error": "Error",
      "cancelled": "Cancelado",
      "canceled": "Cancelado",
    };

    // Buscar coincidencia exacta
    if (translations[statusLower]) {
      return translations[statusLower];
    }

    // Buscar coincidencia parcial
    for (const [key, value] of Object.entries(translations)) {
      if (statusLower.includes(key)) {
        return value;
      }
    }

    // Si ya está en español, devolverlo como está
    return status;
  };

  const columns: ColumnsType<any> = [
    {
      title: "Información de Pago",
      key: "payment_info",
      render: (_, item) => (
        <Space direction="vertical" size={4}>
          <Space size={6}>
            <Hash size={14} style={{ color: "#8c8c8c" }} />
            <Text strong style={{ fontSize: 13 }}>
              ID: {item.id}
            </Text>
          </Space>
          {item.reference && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              Ref: {item.reference}
            </Text>
          )}
          <Text strong style={{ fontSize: 15, color: "#E95735" }}>
            ${decimal(item.value)}
          </Text>
        </Space>
      ),
    },
    {
      title: "Estado",
      key: "status_info",
      render: (_, item) => (
        <Space direction="vertical" size={4}>
          <Tag
            color={getStatusColor(item.status)}
            style={{
              borderRadius: 12,
              padding: "4px 12px",
              fontSize: 12,
              fontWeight: 500,
              border: "none",
            }}
          >
            {translateStatus(item.status)}
          </Tag>
          {item.responseCode && (
            <Text type="secondary" style={{ fontSize: 11 }}>
              Código: {item.responseCode}
            </Text>
          )}
        </Space>
      ),
    },
    {
      title: "Entidad Financiera",
      key: "bank_info",
      render: (_, item) => (
        <Space direction="vertical" size={4}>
          {item.bank && (
            <Space size={6}>
              <Building2 size={14} style={{ color: "#8c8c8c" }} />
              <Text style={{ fontSize: 12 }}>{item.bank}</Text>
            </Space>
          )}
          {item.franchise && (
            <Space size={6}>
              <CreditCard size={14} style={{ color: "#8c8c8c" }} />
              <Text style={{ fontSize: 12 }}>{item.franchise}</Text>
            </Space>
          )}
          {!item.bank && !item.franchise && (
            <Text type="secondary" style={{ fontSize: 12 }}>N/A</Text>
          )}
        </Space>
      ),
    },
    {
      title: "IP",
      dataIndex: "ip",
      key: "ip",
      render: (ip: string) => (
        <Text code style={{ fontSize: 11 }}>
          {ip || "N/A"}
        </Text>
      ),
    },
    {
      title: "Fecha",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_, item) => (
        <Space size={8}>
          <Clock size={14} style={{ color: "#8c8c8c" }} />
          <div>
            <Text style={{ fontSize: 12, display: "block" }}>
              {moment(item.createdAt).format("DD/MM/YYYY")}
            </Text>
            <Text type="secondary" style={{ fontSize: 11 }}>
              {moment(item.createdAt).format("HH:mm:ss")}
            </Text>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <Col
      span={24}
      style={{
        width: "100%",
        display: "flex",
        margin: "auto",
        justifyContent: "flex-start",
        alignItems: "flex-end",
        flexDirection: "column",
      }}
    >
      <Button
        style={{ 
          marginBottom: "12px",
          borderRadius: 20,
          height: 36,
          paddingLeft: 20,
          paddingRight: 20,
          fontWeight: 500,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "center",
          gap: 6
        }}
        type="primary"
        onClick={getRefreshSingleOrder}
        disabled={isLoading}
        loading={isLoading}
        icon={<RotateCw size={16} />}
      >
        Actualizar
      </Button>
      <Table
        style={{ 
          width: "100%",
          borderRadius: 8,
          overflow: "hidden"
        }}
        pagination={false}
        columns={columns}
        dataSource={OrderPaymentConfirmations}
        rowKey="id"
        size="middle"
      />
    </Col>
  );
};
